import { FC } from 'react';

import { type TooltipProps } from '@hh.ru/magritte-ui-tooltip/types';

const ArrowSmall: FC<{ className: string }> = ({ className }) => (
    <svg
        className={className}
        width="18"
        height="12"
        viewBox="0 0 18 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.8035 9.82531L10.2206 6.2092C9.62237 5.37167 8.37763 5.37167 7.7794 6.2092L5.19646 9.82531C4.44562 10.8765 3.23333 11.5004 1.94153 11.5004H1.5L1.5 12.5004L16.5 12.5004V11.5004H16.0585C14.7667 11.5004 13.5544 10.8765 12.8035 9.82531Z"
            fill="var(--magritte-ui-tooltip-arrow-fill)"
            stroke="var(--magritte-ui-tooltip-arrow-stroke)"
        />
    </svg>
);

const ArrowMedium: FC<{ className: string }> = ({ className }) => (
    <svg
        className={className}
        width="28"
        height="12"
        viewBox="0 0 28 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 11.4996H-0.5L-0.5 11.9996L-0.5 13L-0.5 13.5H0L28 13.5H28.5V13V11.9996V11.4996H28L25.845 11.4996C23.5666 11.4996 21.4118 10.4639 19.9885 8.68482L15.9522 3.63943C14.9514 2.38842 13.0486 2.38842 12.0478 3.63943L8.01152 8.68482C6.58823 10.4639 4.43338 11.4996 2.155 11.4996H0Z"
            fill="var(--magritte-ui-tooltip-arrow-fill)"
            stroke="var(--magritte-ui-tooltip-arrow-stroke)"
        />
    </svg>
);

export const TooltipArrow: FC<{ className: string; size: TooltipProps['size'] }> = ({ className, size }) =>
    size === 'small' ? <ArrowSmall className={className} /> : <ArrowMedium className={className} />;
